// Loader shown at the beginning

export const ReactLoader = () => {
    return (
        <div className="br-app-loader__wrapper">
            <div className="br-app-loader">
                <div className="br-app-loader__ring"></div>
                <div className="br-app-loader__ring br-app-loader__ring-underlay">
                    <div className="br-app-loader__ring-middle"></div>
                </div>
            </div>
        </div>
    );    
};
